import * as React from "react";
import { cn } from "../../lib";

export interface MarketingBadgeProps
	extends React.ComponentPropsWithoutRef<"span"> {
	label?: string;
}

export function MarketingBadge({
	label = "Badge",
	className,
	...props
}: MarketingBadgeProps) {
	return (
		<span
			className={cn(
				"inline-flex items-center gap-x-1.5 rounded-full bg-yellow-400/10 px-2 py-1 font-medium text-xs text-yellow-500",
				className,
			)}
			{...props}
		>
			<svg
				viewBox="0 0 6 6"
				aria-hidden="true"
				className="size-1.5 fill-yellow-400"
			>
				<title>Badge indicator</title>
				<circle r={3} cx={3} cy={3} />
			</svg>
			{label}
		</span>
	);
}
